import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import CommunityForm from "./CommunityForm";

const AddNewModal = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_CDiscussion_Modal, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Discussion"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addCommunityDiscussion"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_CDiscussion_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_CDiscussion_Modal ? Add_CDiscussion_Modal : false}
      width={500}
      recordName="communityDiscussionList"
      form={form}
    >
      <CommunityForm />
    </FormModal>
  );
};

export default AddNewModal;
